import gsap from "gsap"
import ScrollTrigger from "gsap/dist/ScrollTrigger"
import Lenis from "lenis"

/**
 * Initialize smooth scrolling with Lenis
 * @returns {Object} The Lenis instance
 */
export function initSmoothScroll() {
  if (typeof window === "undefined") return null

  // Register GSAP ScrollTrigger
  gsap.registerPlugin(ScrollTrigger)

  // Initialize Lenis with optimized settings for better performance
  const lenis = new Lenis({
    duration: 1.6,        // Increased duration for longer smooth scroll after scroll (was 0.8)
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Improved easing function
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 0.8, // Slightly reduced for smoother feel
    smoothTouch: false,   // Usually better to disable for touch devices
    infinite: false,
    lerp: 0.1,           // Linear interpolation for smoother animation
    syncTouch: true,     // Sync touch events
    syncTouchLerp: 0.1   // Touch lerp for smooth touch scrolling
  })

  // Connect Lenis to GSAP's ScrollTrigger
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }
  
  requestAnimationFrame(raf)
  
  // Update ScrollTrigger when Lenis scrolls
  lenis.on('scroll', ScrollTrigger.update)
  
  // Add resize listener to update Lenis when window size changes
  window.addEventListener('resize', () => {
    lenis.resize()
  })
  
  // Sync ScrollTrigger and Lenis
  ScrollTrigger.scrollerProxy(document.body, {
    scrollTop(value) {
      if (arguments.length) {
        lenis.scrollTo(value)
      }
      return lenis.scroll
    },
    getBoundingClientRect() {
      return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight}
    }
  })
  
  // Remove lagSmoothing as it can interfere with Lenis
  gsap.ticker.lagSmoothing(0)

  return lenis
}

// Singleton instance for global access
let lenisInstance = null

export function getLenisInstance() {
  if (!lenisInstance && typeof window !== "undefined") {
    lenisInstance = initSmoothScroll()
  }
  return lenisInstance
}

export default {
  initSmoothScroll,
  getLenisInstance
}
